export const CLASS_NAME = 'cst-emissions-list-header'
